import { ControllerAPI } from "../api/api";
import createListApiState from "./lib/ListApiState";

export const [
    scenariosSlice,
    loadScenarios,
    updateScenariosManually
] = createListApiState({
    name: "Scenarios",
    execute: ControllerAPI.loadScenarios
});
